//
// RenderMode.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var RenderMode = {
    AUTO:0,
    CANVAS2D:1,
    WEBGL:2,
    WEBGPU:3,
    SVG:4,
    SOFTWARE:5
};
export default RenderMode;
